import "reflect-metadata"
import { Application } from "@/Application"
import { AxiosOptionsInjectKey, LocalOptionsInjectKey, type AxiosOption } from "@/core"
import { LoginPageOptionsInjectKey, MiscPluginOptionsInjectKey, NoticePageOptionsInjectKey, Oauth2PluginOptionsInjectKey, RbacPageOptionsInjectKey, type LoginPageOption, type MiscOptions, type NoticePageOption, type RbacPageOption } from "@/plugins"
import { createChatWoot } from "@huntersofbook/chatwoot-vue"
import { container } from "tsyringe"
import { createApp } from "vue"
import AppVue from "./App.vue"
import i18nLocales from './locales'
import { createHead } from '@vueuse/head'
// import "amfe-flexible";
import "./global.less"
import { pxToRem } from "./plugins"
export * from "./plugins"

const cookiePrefix = "fb-c@"

pxToRem(30)

const env = import.meta.env

/**
 * 应用在启动前修改一些选项
 */
// 登录插件服务
container.register(LoginPageOptionsInjectKey, {
  useValue: {
    redirectTo: "/",
    recordDisabled: false,
    cookieKey: `${cookiePrefix}iota`,
    decoratorComponentName: 'flashbase-signin-decorator',
    // header: {
    //   type: "dynamic",
    //   componentName: "flashbase-system-logo" // @see @iota-cn/ui-scaffolding/src/plugins/base/miscellaneous
    // },
    // oauth2Components: [
    //   "iota-default-oauth2-wechat" // @see @iota-cn/ui-scaffolding/src/plugins/base/oauth2-implements
    // ],
    api: {
      fetchSmsValidationCode: "/v1/api/fb/validations/smses",
      validateSmsCode: "/v1/api/fb/validations/smses/validate",
      signinByCode: "/v1/api/fb/signin_by_code"
    },
    signinMode: "simple"
  } as LoginPageOption
})

container.register(Oauth2PluginOptionsInjectKey, {
  useValue: {
    decoratorComponentName: 'flashbase-signin-decorator',
    apiPort: 9090,
    providers: {
      abroadAuth: false,
      wechat: {
        // appId: 'wxd3d1d2131f2b1b43',
        // scanRedirect: '/oauth2/third_parties/wechat/signin' // 后端 api
        appId: "wxab233b3a0cd37f08",
        cookieKey: `${cookiePrefix}wxk`,
        avatarCookieKey: `${cookiePrefix}wxa`,
        usernameCookieKey: `${cookiePrefix}wxu`,
        userInfoCookieKey: `${cookiePrefix}wxaui`
      }
    }
  }
})

// AXIOS CORE SERVICE
container.register(AxiosOptionsInjectKey,
  env.VITE_AXIOS_URL || env.PROD
    ? {
      useValue: {
        baseURL: env.VITE_AXIOS_URL ?? '/',
      } as AxiosOption,
    }
    : {
      useValue: {
        port: env.VITE_AXIOS_PORT || 9090,
      } as AxiosOption,
    },
)

// i18n
container.register(LocalOptionsInjectKey, {
  useValue: {
    // zh_CN or en_US
    locale: 'zh_CN',
    messages: i18nLocales
  }
})



// disable RBAC; but keep menu.
container.register(RbacPageOptionsInjectKey, {
  useValue: {
    disableRBAC: true
  } as RbacPageOption
})

// disable RBAC; but keep menu.
container.register(MiscPluginOptionsInjectKey, {
  useValue: {
    disableAddHeadControl: true,
    disableConsoleLogo: true,
    template: 2
  } as MiscOptions
})

// Notice Service
container.register(NoticePageOptionsInjectKey, {
  useValue: {
    disabledNotice: true
  } as NoticePageOption
})

const chatwoot = createChatWoot({
  init: {
    baseUrl: "https://service.test.flashbase.com",
    websiteToken: "4obkmw5AjKvuySYzMQciCAGz"
  },
  settings: {
    hideMessageBubble: true,
    position: "right", // This can be left or right
    locale: "zh_CN", // Language to be set
    type: "expanded_bubble", // [standard, expanded_bubble]
    showPopoutButton: true,
    launcherTitle: "联系我们"
  },
  partytown: false
})

const app = createApp(AppVue)
const head = createHead()
app.use(chatwoot)
app.use(head)
const application = new Application(app)
application.run()
